import React from 'react'
import PropTypes from 'prop-types'

// a me-badge-tint status with its icon, so the status never depends on color alone
export const StatusBadge = ({ status }) => (
  <span className={`me-badge-tint me-badge-tint-${status.family}`}>
    {status.icon && (
      <i
        className={`fa-regular fa-${status.icon} me-badge-ico`}
        aria-hidden="true"
      />
    )}
    {status.label}
  </span>
)

StatusBadge.propTypes = {
  status: PropTypes.shape({
    label: PropTypes.string.isRequired,
    family: PropTypes.string.isRequired,
    icon: PropTypes.string,
  }).isRequired,
}

// a value we don't have (never succeeded, no next attempt) shows a dash, not a blank
export const Missing = () => <span className="text-muted">—</span>
